const app_key = process.env.VUE_APP_KEY;
const shellURL = process.env.VUE_APP_SHELL;
const chatURL = process.env.VUE_APP_CHAT;
const cmsURL = process.env.VUE_APP_CMS;
const limitSize = {
  errMsg: 'File size exceeds 20M',
  size: 1024 * 1024 * 20
};
const domain = {
  SSO: process.env.VUE_APP_SSO
};
const status = {
  Pending: {},
  Active: {},
  Suspended: {},
  Cancelled: {}
};
const taskStatus = ['Pending', 'Processing', 'Closed', 'Cancelled'];
const taskType = ['Hardware', 'System', 'Security'];
const eventSeverityOptions = ['critical', 'warning', 'info'];
// 事件 / Task Priority 共用的严重度颜色映射；颜色与 event-list 表格已有视觉一致
const eventSeverityColorMap = {
  critical: 'red',
  warning: 'orange',
  info: 'yellow'
};

const tagType = ['client', 'invoice', 'package', 'ticket', 'product', 'plan', 'software'];
const specificationCategory = ['Config', 'Service'];
const systemPricingAlgorithm = ['None', '4 core', '8 core'];
const perUlrMap = {
  GPU: 'gpu-servers',
  APP: 'applications',
  VM: 'myvps',
  'Bare Metal': 'dedicated-servers',
  SSL: 'ssl',
  Domain: 'domain',
  Custom: 'k8s-servers',
  'Serverless LLM': 'llm-serverless'
};
// AIK client portal connection path by product category + product type
const getAikConnectionPath = (category, productType) => {
  if (category === 'GPU' && productType === 'Bare Metal') {
    return 'gpu-baremetal';
  }
  if (category === 'BareMetal' && productType === 'Bare Metal') {
    return 'cpu-baremetal';
  }
  if (category === 'VPS' && productType === 'VM') {
    return 'cpu-instance';
  }
  if (category === 'GPU' && productType === 'VM') {
    return 'gpu-instance';
  }
  return perUlrMap[productType];
};
const packageCancelStatus = ['Pending Removal', 'Removal Delay', 'Cancelled', 'Restorable'];
export const addonBillingTypes = ['All', 'On-Demand', 'Prepaid'];

const hardwareAddonStatus = [
  {
    text: 'Active',
    value: 'Active'
  },
  {
    text: 'Inactive',
    value: 'Inactive'
  },
  {
    text: 'Staff Only',
    value: 'HalfHidden'
  }
];
const packageCategory = ['Database', 'CMS'];
const company = ['CCS', 'DBM'];
const tenantOptions = ['AIK', 'DBM', 'CCS', 'HWY'];
const eventCategoryOptions = [
  'HARDWARE',
  'SYSTEM',
  'NETWORK',
  'SECURITY',
  'SERVICE',
  'DEPLOYMENT',
  'MANUAL'
];
const eventTypeDown = ['None', 'Reboot', 'Hardware Error', 'OS issue', 'Network issue', 'Others'];
const eventTypeWarning = [
  'Others',
  'Backup Disk Abnormal',
  'Raid Disk Abnormal',
  'Disk Abnormal',
  'IPMI Error',
  'Service Down',
  'VPS Deployment Abnormal'
];
const packageStatus = ['Pending', 'Active', 'Suspended', 'Cancelled', 'Unconfirmed'];
const commissionStatus = ['Pending', 'Invalid', 'Available', 'Withdrawing', 'Withdrawn'];
const withdrawalStatus = ['Pending', 'Approved', 'Rejected', 'Cancelled'];
const sslStatus = ['Initial', 'Pending', 'Active', 'Reissue pending'];
const sslPackageStatus = ['Pending', 'Unconfirmed', 'Active', 'Suspended', 'Cancelled'];
const domainStatus = ['Unpaid', 'Initial', 'Pending', 'Active', 'Suspended', 'Cancelled'];
const domainPackageStatus = ['Pending', 'Unconfirmed', 'Active', 'Suspended', 'Cancelled'];

const deployStatus = ['Pending', 'Active', 'Deploying', 'Failure', 'DeleteFailed', 'Deleted'];
const invoiceStatus = [
  'Unpaid',
  'Partially Paid',
  'Paid',
  'Pending Refund',
  'Partially Refunded',
  'Fully Refunded',
  'Cancelled',
  'Charged Back',
  'Draft'
];
const invoiceTypes = [
  'Manual',
  'Addon',
  'Product_Addon',
  'Upgrade',
  'Billing Cycle',
  'Membership',
  'DailyBackupAddon',
  'Add Funds'
];
const clientStatus = ['Good', 'Uncertain', 'Pending', 'Unverified', 'Closed'];
export const moreInfoStatus = ['Requested', 'Approved', 'Rejected', 'Cancelled'];
export const upgradeUsageDurationOptions = [
  { text: '1-3 months', value: '1-3 months' },
  { text: '3-6 months', value: '3-6 months' },
  { text: '6-12 months', value: '6-12 months' },
  { text: '12+ months', value: '12+ months' }
];
export const verificationStatus = ['Pending', 'Approved', 'Need More Info', 'Rejected'];
const orderStatus = ['Pending', 'Active', 'Cancelled', 'Fraud', 'Invalid'];
const clientType = ['reseller', 'client', 'test'];
const serviceStatus = ['Pending', 'Suspended', 'Cancelled', 'Active'];
const serviceType = ['Web Service', 'Microservice', 'Backend Service', 'Third-Party Service'];
const cancellationTypes = ['Immediate', 'End of Billing Cycle'];
const jobType = [
  'Account Profile Reminding',
  'Database Mart Reviews Invitation',
  'Invoice Create',
  'Invoice Capture',
  'Invoices Generation',
  'Invoice Overdue Reminder',
  'RBD Backup',
  'Invoice Reminder',
  'Package Suspension',
  'Package Termination',
  'Retention',
  'CronResourceClean',
  'ManualCheckAbnormal',
  'OvertimeBackupClean',
  'Pending Package Cancellation',
  'VPS Backup',
  'VPS Backup Deletion',
  'Clear Up VPS Backups',
  'Membership Cancellation',
  'Membership Invoices Generation',
  'Server Purchase Reminder'
];
const jobStatus = ['Normal', 'Abnormal'];
const paymentMethod = [
  'Credit Card',
  'PayPal',
  'Check',
  'AliPay',
  'WeChat Pay',
  'Bank Account',
  'Bank Transfer',
  'Credit Applied'
];
const cancellationReasons = [
  'Overdue On Payment',
  'Cancellation Request',
  'Failed Identity Verification',
  'Cancelled by Agent'
];
const FeedBackType = ['Order And Payment', 'New Feature', 'System Bug', 'Testimonials', 'Other'];
const rentalServerStatus = ['Active', 'Free', 'Cancelled'];
const dedicatedServiceStatus = [
  'Active',
  'Pending',
  'Free',
  'Suspended',
  'Cancelled',
  'Repair Pending',
  'Reloading',
  'Transferring',
  'Deployment Abnormal',
  'Reserved'
];
const productType = ['APP', 'VM', 'Bare Metal', 'Custom', 'SSL', 'Domain', 'Serverless LLM'];
const dedicatedDeploymentStatus = [
  'Active',
  'Pending',
  'Enroll',
  'Deploying',
  'Undeploying',
  'Deploy Failed',
  'Undeploy Failed',
  'Dropout'
];
// 部署锁定原因：与 service_status 正交的"禁止部署"维度，列表展示与过滤复用此枚举
const deployLockReasons = ['Non-Standard Config', 'Bad Disk', 'Other'];
const abnormalIssueType = [
  'POD_ABNORMAL',
  'RESOURCE_ABNORMAL',
  'RUNNING_ABNORMAL',
  'DNS_ABNORMAL',
  'RESTORE_OVERTIME',
  'Application_rbd_usage_over_90%',
  'Application_rbd_space_is_less_than_2G',
  'Pod_mem_usage_over_90%',
  'Pod_cpu_usage_over_90%'
];
const backupIssueType = [
  'Delete snapshot error',
  'Import backupfile error',
  'Unable to connect ceph cluster',
  'Create image error',
  'Create snapshot error',
  'Export backupfile error',
  'Get backupfile error',
  'Get rbd image error',
  'Get statefulset error',
  'Start pod faided',
  'Stop pod faided',
  'Unable to connect kube cluster',
  'Application does not exist',
  'Backup Overtime'
];
const abnormalStatus = ['Pending', 'Cancelled', 'Processing', 'Closed', 'AutoEmail'];
const packageNumber = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '1~5',
  '6~10',
  '10~20',
  '20+'
];
const billingCycle = [
  { text: 'One Time', value: 0 },
  { text: 'Monthly', value: 1 },
  { text: 'Quarterly', value: 3 },
  { text: 'Semi-Annually', value: 6 },
  { text: 'Annually', value: 12 },
  { text: 'Biennially', value: 24 },
  { text: 'Triennially', value: 36 },
  { text: 'Quadrennially', value: 48 },
  { text: 'Quinquennially', value: 60 }
];
const billingCycleHour = [
  // { text: 'One Time', value: 0 },
  { text: 'Hourly', value: 1 }
];

const DisplayUnits = {
  hour: [
    { text: 'hour', value: 1 },
    // { text: '3-hour', value: 3 },
    // { text: '6-hour', value: 6 },
    // { text: '12-hour', value: 12 },
    { text: 'day', value: 24 }
    // { text: '36-hour', value: 36 },
    // { text: '2-day', value: 48 },
    // { text: '60-hour', value: 60 }
  ],
  month: [
    { text: '1-mo', value: 1 },
    { text: '3-mo', value: 3 },
    { text: '6-mo', value: 6 },
    { text: '1-year', value: 12 }
    // { text: '2-year', value: 24 },
    // { text: '3-year', value: 36 },
    // { text: '4-year', value: 48 },
    // { text: '5-year', value: 60 }
  ]
};

const DurationTypes = [
  { text: 'On-Demand', value: 'hour' },
  { text: 'Prepaid ', value: 'month' }
];

const BillingTypes = ['Prepaid', 'On-Demand'];

const fullManaged = ['Support Reload OS', 'Support IPMI', 'No IPMI'];
const BillingSettingArray = [
  {
    name: 'Invoice Generation Before Package Due Date',
    key: 'invoice_gen_days_before_due_date',
    val: ''
  },
  { name: 'Suspension For Overdue Package', key: 'auto_suspension_days', val: '' },
  { name: 'Termination After Suspension For Overdue Package', key: 'auto_terminate_days', val: '' },
  {
    name: 'Termination After Suspension For Free Trial Package',
    key: 'free_trial_terminate_days',
    val: ''
  },
  {
    name: 'Suspension For Submitted Cancellation Request',
    key: 'cancellation_request_suspend_days',
    val: ''
  },
  {
    name: 'Termination After Suspension For Submitted Cancellation Request',
    key: 'cancellation_request_terminate_days',
    val: ''
  },
  {
    name: 'Reminder Email Before A Credit Card’s Expiration Date',
    key: 'auto_credit_card_remind_days',
    val: ''
  },
  {
    name: 'Cancellation To Free Interval Days',
    key: 'dedicate_cancel_protection_period',
    val: ''
  },
  { name: 'Late Fee Adding After Due Date', key: 'late_fee_add_days_after_due_date', val: '' },
  { name: 'Late Fee Per Day', key: 'late_fee_per_day', val: '' },
  {
    name: '1st Overdue Reminder After Package Due Date',
    key: 'first_overdue_reminder_days',
    val: ''
  },
  {
    name: '2nd Overdue Reminder After Package Due Date',
    key: 'second_overdue_reminder_days',
    val: ''
  },
  {
    name: '3rd Overdue Reminder After Package Due Date',
    key: 'third_overdue_reminder_days',
    val: ''
  },
  {
    name: '1st Reminder To Complete Info Before The End Of Free Trial',
    key: 'complete_info_days_before_trial_period_end',
    val: ''
  },
  {
    name: '2nd Reminder To Complete Info Before The End Of Free Trial',
    key: 'second_reminder_days_before_trial_period_end',
    val: ''
  },
  {
    name: 'Short Trial Reminder To Complete Info Before The End Of Free Trial',
    key: 'short_complete_info_days_before_trial_period_end',
    val: ''
  },
  {
    name: 'Re-capture A Credit Card That Failed The First Charge',
    key: 'next_charge_invoice_days_record',
    val: ''
  },
  {
    name: 'Cancellation Of New Orders Without Deploying APPs',
    key: 'days_to_cancellation_of_new_order_without_deploying_apps',
    val: ''
  },
  { name: 'The first survey after app installation', key: 'first_return_visit_days', val: '' },
  {
    name: 'The second survey after app installation ',
    key: 'secondvisitinforoutine_days',
    val: ''
  },
  {
    name: 'Payment reminder before due date',
    key: 'invoicewilloverdueremindinforoutine_days',
    val: ''
  },
  {
    name: 'No-order reminder after registration--(hours)',
    key: 'none_order_reminder_hour',
    val: ''
  },
  { name: 'Suspension reminder after due date', key: 'suspend_reminder_days', val: '' },
  { name: 'Cancellation reminder after due date', key: 'invoice_cancel_reminder_days', val: '' },
  { name: 'FTP service duration--(hours)', key: 'ftp_assist_survival_time', val: '' },
  { name: 'Maximum number of firewall rules', key: 'app_ip_rules_max_number', val: '' },
  { name: 'Trail APP max number', key: 'trial_app_max_number', val: '' },
  { name: 'Maximum number of trial APP per product', key: 'trial_app_product_max_number', val: '' },
  {
    name: 'Maximum number of concurrent trial APP per product',
    key: 'trial_app_concurrent_max_num',
    val: ''
  },
  { name: 'Auto Verify Mini Score', key: 'auto_vefify_mini_score', val: '' },
  { name: 'Card Gateway', key: 'card_gateway', val: '' },
  { name: 'Maximum number of Split Payment', key: 'split_payment_limit', val: '' },
  { name: 'Minimux amount of per payment', key: 'min_payment_per_time', val: '' },
  { name: 'Free Trial Verification Option', key: 'free_trial_verification_option', val: '' },
  {
    name: 'Maximum Number of Trial Packages Per Country Per Time Window',
    key: 'max_trial_packages_per_country_per_time_window',
    val: ''
  },
  {
    name: 'Reseller apps trial threshold list',
    key: 'trial_app_threshold',
    value: []
  },
  {
    name: 'Reseller maximum number of apps trials',
    key: 'reseller_trial_app_count',
    value: ''
  },
  {
    name: 'Highend VPS Max Count',
    key: 'highend_vps_max_count',
    val: ''
  },
  {
    name: 'Highend VPS Recent Days',
    key: 'highend_vps_recent_days',
    val: ''
  },
  {
    name: 'Windows VPS CPU Usage Percent Threshold(%)',
    key: 'high_plan_vps_cpu_usage_percent',
    val: ''
  },
  {
    name: 'Windows VPS CPU Usage Alert Interval Days',
    key: 'high_plan_vps_cpu_usage_days',
    val: ''
  },
  {
    name: 'Linux KVM VPS CPU Usage Percent Threshold(%)',
    key: 'high_cpu_kvm_vps_usage_percent',
    val: ''
  },
  {
    name: 'Linux KVM VPS CPU Usage Alert Interval Days',
    key: 'high_cpu_kvm_vps_usage_days',
    val: ''
  }
];
const vpsType = [
  'GPU Hosting Server',
  'Linux Hosting Server',
  'Windows Hosting Server',
  'Windows Desktop Host'
];
const SignUpSettingArray = [
  { name: 'Signup Client Information Mode', key: 'client_info_config', val: '' },
  { name: 'Signup Email Validation Mode', key: 'email_verify_config', val: '' },
  { name: 'Signup Robot Protection', key: 'need_robot_protection', val: '' },
  { name: 'Signup Fingerprint', key: 'fingerprint_enabled', val: '' },
  { name: 'Signup Fingerprint Check Cycle(hours)', key: 'fingerprint_check_cycle_hours', val: '' },
  { name: 'Signup IP Check', key: 'ip_check_enabled', val: '' },
  { name: 'Login Robot Protection', key: 'login_need_robot_protection', val: '' },
  { name: 'Login 2FA', key: 'login_email_verify_config', val: '' },
  { name: 'Login 2FA Check Mode', key: 'client_login_2fa_check_mode', val: '' },
  { name: 'Login Event Check Time Window(minutes)', key: 'login_event_check_time_window', val: '' },
  { name: 'Login Event Check Threshold', key: 'login_event_check_threshold', val: '' },
  {
    name: 'Login Event Protection Release Time Window(minutes)',
    key: 'login_event_protection_release_time_window',
    val: ''
  },
  {
    name: 'Login Event Protection Release Threshold',
    key: 'login_event_protection_release_threshold',
    val: ''
  },

  {
    name: 'Invalid Login Ip Check Time Window(minutes)',
    key: 'invalid_login_ip_check_time_window',
    val: ''
  },
  { name: 'Invalid Login Ip Check Threshold', key: 'invalid_login_ip_check_threshold', val: '' },
  {
    name: 'Invalid Login Ip Protection Release Time Window(minutes)',
    key: 'invalid_login_ip_protection_release_time_window',
    val: ''
  },
  {
    name: 'Invalid Login Ip Protection Release Threshold',
    key: 'invalid_login_ip_protection_release_threshold',
    val: ''
  },
  {
    name: 'Signup Gift Credit',
    key: 'signup_gift_credit',
    val: ''
  }
];
const StaffSignUpSettingArray = [
  { name: 'Login 2FA', key: 'staff_login_verify_method', val: '' },
  {
    name: 'Login Verification Exemption Days',
    key: 'staff_login_verification_exemption_days',
    val: ''
  },
  { name: 'Verification Code Daily Limit', key: 'verification_code_daily_limit', val: '' },
  { name: 'Verification Code Cooldown(minutes)', key: 'verification_code_cooldown', val: '' },
  { name: 'Login Need Robot Protection', key: 'staff_login_need_robot_protection', val: '' },
  { name: 'Login Reminder', key: 'staff_login_reminder', val: '' }
];

const colorMap = {
  // Celery 执行结果和调度检查状态使用后台原始值，避免未知状态默认显示红色。
  PUBLISHED: 'blue',
  RUNNING: 'primary',
  SUCCESS: 'success',
  FAILURE: 'error',
  RETRY: 'warning',
  REVOKED: 'grey',
  REJECTED: 'warning',
  IGNORED: 'grey',
  EXPIRED: 'grey',
  UNKNOWN: 'grey',
  OK: 'success',
  WAITING: 'info',
  MISSED: 'error',
  DISABLED: 'grey',
  COMPLETED: 'success',
  NOT_READY: 'warning',
  EXCLUDED: 'grey',
  Enabled: 'success',
  Disabled: 'grey',
  Active: 'success',
  Withdrawn: 'success',
  MQL: 'success',
  Unconfirmed: '#F57D0E',
  Online: 'success',
  Offline: '#ccc',
  Inactive: '#ccc',
  Invalid: '#ccc',
  Deleted: '#ccc',
  Free: '#ccc',
  Expired: '#ccc',
  Unverified: 'accent',
  Approved: 'success',
  Success: 'success',
  Waiting: 'info',
  Requested: 'info',
  Accept: 'info',
  Deploying: 'warning',
  Withdrawing: 'warning',
  Deleting: 'warning',
  Processing: 'blue',
  ProcessingAuto: 'blue',
  ProcessingManual: 'blue',
  Failure: 'error',
  Rejected: 'error',
  Process: 'blue',
  Following: 'blue',
  Pending: 'warning',
  PendingCustomer: 'warning',
  PendingStock: 'warning',
  Completed: 'success',
  Initial: 'warning',
  'Need More Info': 'warning',
  'Pending Activation': 'warning',
  'Pending Removal': 'warning',
  'Reissue pending': 'warning',
  'Reissue Pending': 'warning',
  Good: 'success',
  Uncertain: 'rgba(220, 228, 92, 1)',
  Fraud: 'error',
  Cancelling: 'warning',
  Suspended: 'blue',
  Cancelled: '#ccc',
  Closed: '#ccc',
  Paid: 'success',
  'Partially Paid': '#5574E5',
  Unpaid: 'error',
  Draft: 'info',
  'Fully Refunded': '#ab099b',
  'Charged Back': '#ab099b',
  'Pending Refund': '#FB8B24',
  Restorable: '#5574E5',
  Adding: '#FB8B24',
  'Partially Refunded': '#d89be4',
  Normal: 'success',
  Succeeded: 'success',
  Running: 'success',
  Installing: '#E6A23C',
  Exporting: 'warning',
  DeleteFailed: '#D9001B',
  Rollback: '#0688d9',
  Clear: 'green',
  Restricted: '#ff5252',
  Unrestricted: '#1867c0',
  Available: '#1867c0',
  WhiteListed: '#4caf50',
  AutoEmail: '#fb8c00',
  Open: '#fa0',
  UnderReview: '#ccc',
  Canceled: '#fa0',
  Refunded: '#4422bf',
  Won: '#008556',
  Lost: '#ccc',
  'No Need': '#ccc',
  Done: 'success',
  Timeout: 'error',
  Exception: 'warning',
  'Staff Only': '#1867c0',
  'Removal Delay': '#ab099b'
};

const deviceType = ['CPU', 'Memory', 'Power', 'Disk', 'Chassis', 'Motherboard'];
const dataCenters = ['Denver', 'Dallas'];
const trialType = ['None', 'Requested', 'Approved', 'Rejected', 'More Info Required'];
const markingType = ['Difficulty', 'Share'];
const markingStatus = ['Pending', 'Reviewed', 'Pending training', 'Closed'];
const ticketScene = [
  {
    type: 'Server Available',
    getLevel: function (duration) {
      return duration < 3600 * 2 ? 2 : 3;
    }
  },
  {
    type: 'Business Available',
    getLevel: function (duration) {
      return duration < 3600 * 12 ? 1 : 2;
    }
  },
  {
    type: 'Sales & Marketing',
    getLevel: function (duration) {
      return duration < 3600 * 12 ? 1 : 2;
    }
  },
  {
    type: 'Unrelated Issues',
    getLevel: function () {
      return 1;
    }
  }
];
export {
  company,
  perUlrMap,
  getAikConnectionPath,
  orderStatus,
  shellURL,
  productType,
  chatURL,
  cmsURL,
  deviceType,
  dataCenters,
  packageNumber,
  backupIssueType,
  BillingSettingArray,
  SignUpSettingArray,
  StaffSignUpSettingArray,
  cancellationReasons,
  billingCycle,
  billingCycleHour,
  DisplayUnits,
  DurationTypes,
  BillingTypes,
  jobStatus,
  jobType,
  FeedBackType,
  abnormalIssueType,
  abnormalStatus,
  paymentMethod,
  colorMap,
  domain,
  status,
  packageCategory,
  packageStatus,
  deployStatus,
  cancellationTypes,
  invoiceStatus,
  invoiceTypes,
  app_key,
  limitSize,
  clientStatus,
  clientType,
  serviceStatus,
  serviceType,
  rentalServerStatus,
  fullManaged,
  vpsType,
  trialType,
  dedicatedServiceStatus,
  dedicatedDeploymentStatus,
  deployLockReasons,
  commissionStatus,
  withdrawalStatus,
  sslStatus,
  sslPackageStatus,
  domainStatus,
  eventTypeDown,
  eventTypeWarning,
  domainPackageStatus,
  markingType,
  markingStatus,
  specificationCategory,
  tagType,
  systemPricingAlgorithm,
  packageCancelStatus,
  hardwareAddonStatus,
  ticketScene,
  tenantOptions,
  eventCategoryOptions,
  eventSeverityOptions,
  eventSeverityColorMap,
  taskStatus,
  taskType
};

export const affiliate_invalid_reasons = [
  'Violation of AFF TOS - The order violates the Affiliate Terms of Service',
  'Less than 40 Days of Validity - The order does not meet the required 40-day validity period',
  "Fraud - The order is flagged as fraudulent based on our system's detection",
  'Others - Any other reasons that render the order invalid'
];

export const rejectTrialReasons = [
  'Trial Limit – Customer has exceeded allowed number of trials',
  'Multi-Account – Multiple accounts requesting trials; suspected abuse',
  'Out of Stock – Product unavailable for trial',
  'Poor Account Info – Account information incomplete, inaccurate, or unverifiable',
  'Invalid Usage – Intended use does not match product; suspected fraud',
  'Others',
  'None'
];
export const uncertainClosedReasons = [
  'Account Verification Failed-- Account, identity, or card information not passed',
  'High Risk Payment --Flagged as Early Fraud, Elevated Risk, or chargebacks',
  'Bulk Fraud--High-risk countries, domains, or suspected bulk/fraudulent activity',
  'Abuse Risk--High risk usage, suspected policy violation, resource abuse',
  'Duplicate Acc--Multiple accounts without valid reason',
  'Sanctioned Country--Customer from sanction regions',
  'Others',
  'None'
];

export const saleLeadStatus = ['Pending', 'Processing', 'Won', 'Lost', 'Invalid'];
export const saleLeadChannel = [
  'Sales TK',
  'Sales LC',
  'Web Form',
  'WeChat',
  'Telegram',
  'RCL',
  'Others'
];
export const lostReason = [
  'Requirement Mismatch',
  'Price concerns/ Budget Mismatch',
  'Technical or Product Factors',
  'Trust and Security Concerns',
  'Follow-up but no response',
  'Others'
];
// Card Tracking 筛选用: ACH 银行列表(value 即用于 card_type icontains 匹配 Stripe 返回的 bank_name)
export const achBankList = [
  'Chase',
  'Bank of America',
  'Wells Fargo',
  'Citibank',
  'U.S. Bank',
  'PNC Bank',
  'Capital One',
  'TD Bank',
  'Truist',
  'USAA',
  'Navy Federal'
];
// Card Tracking 筛选用: 信用卡品牌列表
export const creditCardBrandList = [
  'Visa',
  'Mastercard',
  'American Express',
  'Discover',
  'JCB',
  'Diners Club',
  'UnionPay'
];

export const quoteStatus = ['Active', 'Accept', 'Expired', 'Cancelled'];
export const quoteSource = ['TK', 'LC', 'Others'];
export const deliveryStatus = [
  'ProcessingAuto',
  'ProcessingManual',
  'PendingStock',
  'PendingCustomer',
  'Completed'
];

// Work Management Constants
export const requirementStatus = ['Pending', 'Planned', 'Deferred', 'Completed'];
export const requirementSource = [
  'Customer',
  'Support',
  'Operation',
  'Marketing',
  'Product',
  'Internal Optimization'
];
export const priorityOptions = ['High', 'Medium', 'Low'];
export const impactOptions = ['High', 'Medium', 'Low'];
export const projectStatus = ['Planning', 'Processing', 'Completed'];
export const taskStatusList = [
  'Not Started',
  'In Progress',
  'Waiting',
  'Joint Debugging',
  'Ready for Test',
  'Testing',
  'Ready for Release',
  'Closed'
];
export const issueStatusList = [
  'New',
  'In Progress',
  'Ready for Test',
  'Closed',
  'Reopen',
  'Needs Info',
  'Rejected',
  "Won't Fix"
];
export const issueTypeList = ['Bug', 'Suggestion', 'ISSUE_PRD', 'Legacy_Bug'];
export const issuePriorityList = ['High', 'Medium', 'Low'];
export const storyStatusList = ['Open', 'In Progress', 'Ready for Test', 'Testing', 'Closed'];

export const taskDifficultyOptions = ['Normal', 'Medium', 'High'];
export const taskDifficultyWorkloadRange = {
  Normal: [1, 3],
  Medium: [4, 6],
  High: [7, 10]
};

// Task 质量评分选项：value 与后端 quality_score 一一对应（星星数 = value）
// 1=Pass / 2=Excellent / 3=Outstanding
export const taskQualityScoreOptions = [
  { value: 1, label: 'Pass' },
  { value: 2, label: 'Excellent' },
  { value: 3, label: 'Outstanding' }
];

// quality_score -> label 快速映射，供星星 tooltip 展示
export const taskQualityScoreLabelMap = {
  1: 'Pass',
  2: 'Excellent',
  3: 'Outstanding'
};

// ========== Work Management 状态颜色映射 ==========

// Task 状态颜色
export const taskStatusColorMap = {
  'Not Started': 'grey',
  'In Progress': 'primary',
  Waiting: 'warning',
  'Joint Debugging': 'info',
  'Ready for Test': 'purple',
  Testing: 'orange',
  'Ready for Release': 'teal',
  Closed: 'success'
};

// Story 状态颜色
export const storyStatusColorMap = {
  Open: 'grey',
  'In Progress': 'primary',
  'Ready for Test': 'purple',
  Testing: 'orange',
  Closed: 'success'
};

// Issue 状态颜色
export const issueStatusColorMap = {
  New: 'grey',
  'In Progress': 'primary',
  'Ready for Test': 'purple',
  Closed: 'success',
  Reopen: 'warning',
  'Needs Info': 'info',
  Rejected: 'error',
  "Won't Fix": 'brown'
};

// Project 状态颜色
export const projectStatusColorMap = {
  Planning: 'warning',
  Processing: 'primary',
  Completed: 'success'
};

// Requirement 状态颜色
export const requirementStatusColorMap = {
  Pending: 'warning',
  Planned: 'primary',
  Deferred: 'grey',
  Completed: 'success'
};

// Issue Type 颜色
export const issueTypeColorMap = {
  Bug: 'error',
  Suggestion: 'info',
  ISSUE_PRD: 'warning',
  Legacy_Bug: 'grey'
};

// Issue Priority 颜色
export const issuePriorityColorMap = {
  High: 'error',
  Medium: 'warning',
  Low: 'success'
};

// 工作项类型颜色（Task / Story / Issue）
export const workItemTypeColorMap = {
  Task: 'primary',
  Story: 'success',
  Issue: 'warning'
};

// 根据工作项 type + status 获取对应状态颜色
export function getWorkItemStatusColor(type, status) {
  if (type === 'Task') return taskStatusColorMap[status] || 'grey';
  if (type === 'Story') return storyStatusColorMap[status] || 'grey';
  if (type === 'Issue') return issueStatusColorMap[status] || 'grey';
  return 'grey';
}
